module.exports = __webpack_public_path__ + "img/ETH.61dc5919.png";